import { InjectionToken } from '@angular/core';

export const BYD_API_INJECTION_TOKEN = new InjectionToken('The api configuration injection token');
